/**
 * @fileoverview GET handler for the "/apps/:app_group_id/charts/push" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { appsAppGroupIdChartsPush } from "./constants";
import type { AppsAppGroupIdChartsPushResult } from "./types";

export const getAppsAppGroupIdChartsPush = reactQueryFetcherAdapter(
  appsAppGroupIdChartsPush,
  (
    signal: AbortSignal,
    appGroupId: string,
    startDate: number,
    endDate: number
  ): Promise<AppsAppGroupIdChartsPushResult> => {
    return fetch(
      `/apps/${appGroupId}/charts/push`,
      "GET",
      { start_date: startDate, end_date: endDate },
      { signal }
    );
  }
);
